var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlusPrimary(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/pluc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1429 8.85714H8.85714V13.1429C8.85714 13.3702 8.76684 13.5882 8.60609 13.7489C8.44535 13.9097 8.22733 14 8 14C7.77267 14 7.55465 13.9097 7.39391 13.7489C7.23316 13.5882 7.14286 13.3702 7.14286 13.1429V8.85714H2.85714C2.62981 8.85714 2.4118 8.76684 2.25105 8.60609C2.09031 8.44535 2 8.22733 2 8C2 7.77267 2.09031 7.55465 2.25105 7.39391C2.4118 7.23316 2.62981 7.14286 2.85714 7.14286H7.14286V2.85714C7.14286 2.62981 7.23316 2.4118 7.39391 2.25105C7.55465 2.09031 7.77267 2 8 2C8.22733 2 8.44535 2.09031 8.60609 2.25105C8.76684 2.4118 8.85714 2.62981 8.85714 2.85714V7.14286H13.1429C13.3702 7.14286 13.5882 7.23316 13.7489 7.39391C13.9097 7.55465 14 7.77267 14 8C14 8.22733 13.9097 8.44535 13.7489 8.60609C13.5882 8.76684 13.3702 8.85714 13.1429 8.85714Z",
    fill: "#5A8DF1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusPrimary);
export default __webpack_public_path__ + "static/media/ic_plus_primary.2249ce7027475ab397045bdee8f1fcca.svg";
export { ForwardRef as ReactComponent };